<template>
	<div class="technology">
		<img
			v-show="lang === 'en-US'"
			class="first-img"
			src="../assets/imgs/TFT-en.jpg"
		/>

		<img v-show="lang === 'zh-CN'" src="../assets/imgs/TFT.jpg" />
		<div class="contact-title">
			<div class="contact-title-t1">{{ $t("tFeatures") }}</div>
			<span></span>
		</div>
		<ul class="technology-advantage">
			<li v-for="(item, index) in $t('TFT')" :key="index">
				<div>{{ item }}</div>
			</li>
		</ul>
		<div class="sec-img-box">
			<img
				v-show="lang === 'en-US'"
				src="../assets/imgs/OLED.jpg"
				alt=""
			/>
			<!-- 英文的图，要换 -->
			<img v-show="lang === 'zh-CN'" src="../assets/imgs/OLED.jpg" />
		</div>
		<div class="contact-title">
			<div class="contact-title-t1">{{ $t("oFeatures") }}</div>
			<span></span>
		</div>
		<ul class="technology-advantage">
			<li v-for="(item, index) in $t('OLED')" :key="index">
				<div>{{ item }}</div>
			</li>
		</ul>
		<div class="contact-title">
			<div class="contact-title-t1">{{ $t("technology") }}</div>
			<span></span>
		</div>
		<div class="technology-box">
			<img src="../assets/imgs/technology.jpg" alt="" />
		</div>
		<div class="contact-title">
			<div class="contact-title-t1">{{ $t("Fit.title") }}</div>
			<span></span>
		</div>
		<div class="technology-fit">
			<div>
				<h3>{{ $t("Fit.not1") }}</h3>
				<h3>{{ $t("Fit.not2") }}</h3>
				<h3>{{ $t("Fit.not3") }}</h3>
				<img src="../assets/imgs/noT.png" alt="" />
			</div>
			<div>
				<h3>{{ $t("Fit.yes1") }}</h3>
				<h3>{{ $t("Fit.yes2") }}</h3>
				<h3>{{ $t("Fit.yes3") }}</h3>
				<img src="../assets/imgs/yes.png" alt="" />
			</div>
		</div>

		<div class="technology-fit-example">
			<div>
				{{ $t("Fit.example") }}<i class="el-icon-bottom-right"></i>
			</div>
			<div class="img-box">
				<img src="../assets/imgs/effect.png" alt="" />
			</div>
		</div>
		<div>
			<div class="technology layout-baby">
				<img src="../assets/imgs/lcd.jpg" alt="" />
			</div>

			<div class="technology layout-baby">
				<img src="../assets/imgs/amoled.jpg" alt="" />
			</div>

			<div class="technology layout-baby">
				<img src="../assets/imgs/touch.jpg" alt="" />
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			// lang: this.$cookies.get("SET_LANG")
		};
	},
	computed: {
		lang() {
			return this.$store.state.locale;
		},
	},
	created() {},
};
</script>
<style lang="scss">
.technology {
	margin-bottom: 60px;
	> img {
		width: 100%;
	}
	.technology-advantage {
		width: 1000px;
		display: flex;
		flex-wrap: wrap;
		margin: 0 auto;
		padding-bottom: 40px;
		li {
			width: calc(25% - 32px);
			text-align: center;
			height: 140px;
			border-radius: 50%;
			border: 1px solid #ccc;
			margin: 8px 16px;
			box-shadow: 13px 13px 20px 0px #ccc;
			font-size: 20px;
			position: relative;
			div {
				width: 100%;
				padding: 0 4px;
				position: absolute;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
			}
		}
	}
	.sec-img-box {
		width: 1000px;
		text-align: center;
		margin: 24px auto;
	}
	.contact-title {
		visibility: visible;
		animation-name: fadeInUp;
		text-align: center;
		width: 1200px;
		margin: 0 auto;
		padding: 4% 0 3%;
		.contact-title-t1 {
			font-size: 30px;
			color: #666;
		}
		.contact-title-t2 {
			font-size: 20px;
			color: #333;
		}
		span {
			display: inline-block;
			width: 33px;
			height: 3px;
			background: #ff9801;
			margin: 10px 0;
		}
	}
	.technology-box {
		width: 1000px;
		margin: 0 auto;
		text-align: center;
	}
	.technology-fit {
		width: 1000px;
		margin: 0 auto;
		display: flex;
		div {
			flex: 1;
			padding: 0 32px;
			img {
				width: 443px;
			}
		}
		h3 {
			line-height: 24px;
			padding-left: 24px;
			font-weight: 600;
		}
	}
	.technology-fit-example {
		width: 1000px;
		margin: 0 auto;
		font-size: 24px;
		padding-top: 20px;
		color: #666;
		.el-icon-bottom-right {
			color: #ff9801;
		}
		.img-box {
			text-align: center;
		}
	}
}
</style>
